import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import RotateDevice from "./RotateDevice";
import UnderConstruction from "./UnderConstruction";
import UpdatingVersion from "./UpdatingVersion";

const BlockerPages = withLiteObserverAndTheme(() => {
  const shouldRotateDevice = getCoreUIStore().rotateDevice.get();

  const adminShouldUpdate =
    !getCorePersonalStore().adminCurrentVersionIsActive.get();
  const adminIsUnderMaintenance =
    getCorePersonalStore().adminUnderMaintenance.get();

  const shoulShowUpdate = adminShouldUpdate && !adminIsUnderMaintenance;
  return shoulShowUpdate ? (
    <UpdatingVersion />
  ) : adminIsUnderMaintenance ? (
    <UnderConstruction />
  ) : shouldRotateDevice ? (
    <RotateDevice />
  ) : null;
});
export default BlockerPages;
